export const contactFormUrl =
  "https://form.jotform.com/btdigital/bt-feedback-form?utm_source=btweb&utm_medium=shortlink&utm_campaign=feedback_form";
export const newspostUrl = "https://newspost.newslink.sg/";

export const sphText = "Copyright SPH Media. All rights reserved.";
export const nonSphText =
  "Share with us your feedback on BT's products and services";
